import request from "../request";

export function getActiveRounds(params) {
    return request({
        url: "/driver-active-round",
        method: "get",
        params
    })
}